"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _KeycloakProvider = _interopRequireDefault(require("./KeycloakProvider"));

var AuthProvider = function AuthProvider(props) {
  var authentication = props.authentication;

  if (authentication.keycloak) {
    return /*#__PURE__*/_react.default.createElement(_KeycloakProvider.default, props);
  }

  return null;
};

AuthProvider.propTypes = {
  authentication: _propTypes.default.shape({
    required: _propTypes.default.bool,
    AuthComponent: _propTypes.default.elementType,
    keycloak: _propTypes.default.shape({
      providerProps: _propTypes.default.object,
      config: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired
    })
  }),
  children: _propTypes.default.node
};
AuthProvider.displayName = 'AuthProvider';
var _default = AuthProvider;
exports.default = _default;